
import { HttpAnnounceList, HttpReadAnnounce } from '../../../service/notice';
import TableList from "../../../components/templates/tablelist";
import mixin from '../mixin';
import compDetail from './detailmodal';

export default {
    mixins: [TableList, mixin],
    components: {
        compDetail
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                // search: {
                //     EQ_notifyReadStatus: null
                // }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    mounted () {
        this.$set(this.$refs.compSearchs.formData, 'keyword', this.$route.query.keyword)
    },
    methods: {
        ajaxRequest: HttpAnnounceList,
        interceptRequest: (params) => {
            return {
                ...params,
                keyword: params.search.keyword,
                search: {}
            }
        },
        handleOperates(params, type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case 'query':
                    console.log(this.formData)
                    this.operate = {
                        show: true,
                        id: params,
                        page: this.formData.page,
                        row: this.formData.rows,
                        title: "公告",
                        component: "compDetail",
                       	width: '720',
                        showFooter: false
                    };
                    break;
            }
        },
    },
    computed: {
        SearchsData() {
            return [
                {
                    label: "标题",
                    key: 'keyword',
                    tag: 'vInput',
                    show: true,
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: '#',
                    type: 'index',
                    width: 40,
                    align: 'center',
                },
                {
                    title: '标题',
                    key: 'title',
                    render: (h, { row }) => {
                        return <span class="color-link" onClick={this.handleOperates.bind(this, row.id, 'query')}>{row.title}</span>
                    },
                },
                {
                    title: '简述',
                    key: 'brief',
                    // render: (h, { row }) => {
                    //     return <div class={{ 'font-bold': row.notifyReadStatus == 0 }}>{row.brief}:{row.srcLabel}</div>
                    // },
                },
                {
                    title: '创建人',
                    width: 100,
                    key: 'createdName'
                }, 
                {
                    title: '日期',
                    width: 150,
                    key: 'createdAt',
                }];
        },
    },
};




